/**
 * Location type enum for frontend and API
 * Frontend supports: building, floor, room, outdoor, otherSpaces
 * API currently supports: room, outdoor, otherSpaces
 */
export const LocationType = {
  BUILDING: 'building',
  FLOOR: 'floor',
  ROOM: 'room',
  OUTDOOR: 'outdoor',
  OTHER_SPACES: 'otherSpaces',
} as const;

export type LocationType = (typeof LocationType)[keyof typeof LocationType];

/**
 * Location object for item assignment and filtering
 * Can represent a building, floor, room, outdoor space, or other space
 */
export interface Location {
  id: string;
  type: LocationType;
}

/**
 * API-supported location types (subset of LocationType)
 */
export const ApiLocationType = {
  ROOM: LocationType.ROOM,
  OUTDOOR: LocationType.OUTDOOR,
  OTHER_SPACES: LocationType.OTHER_SPACES,
} as const;

export type ApiLocationType = (typeof ApiLocationType)[keyof typeof ApiLocationType];

/**
 * Special marker to indicate "Other Spaces" selection in cascader
 */
export const OTHER_SPACES_MARKER = 'OTHER_SPACES' as const;
